<template>
  <div v-loading.body="loading">
    <!--<div class="c_page-title">-->
    <!--<el-button class="icon-fresh" size="mini" icon="el-icon-refresh" @click="fetchData(true)">刷新</el-button>-->
    <!--</div>-->
    <div
      v-if="resData"
      class="row"
      :gutter="20"
      type="flex"
      align="middle"
      justify="start"
    >
      <div
        v-for="item in storehouseIds"
        v-if="item.key !== -1"
        :key="item.key"
        class="status"
        :class="{ active: origin === item.key }"
        @click="selectOrigin(item.key)"
      >
        {{ item.label }}
      </div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form :inline="true" :model="form" class="demo-form-inline">
                  <el-form-item>
                    <el-select
                      v-model="search_type"
                      placeholder="波次号"
                      style="width: 150px"
                    >
                      <el-option
                        v-for="item in search_options"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item style="margin-left: -15px; width: 165px">
                    <el-input
                      v-model="search_value"
                      placeholder="请输入搜索内容"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.shipping_company"
                      placeholder="快递公司"
                      style="width: 150px"
                    >
                      <el-option value="">全部</el-option>
                      <el-option
                        v-for="item in conditionData.shipping_company"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item>
                    <el-select
                      v-model="form.cod_type"
                      placeholder="处理类型"
                      style="width: 150px"
                    >
                      <el-option value="">全部</el-option>
                      <el-option
                        v-for="(item, index) in conditionData.cod_type"
                        v-if="item != ''"
                        :key="index"
                        :label="item"
                        :value="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item>
                    <el-select
                      v-model="form.cod_status"
                      placeholder="处理状态"
                      style="width: 150px"
                    >
                      <el-option value="">全部</el-option>
                      <el-option
                        v-for="(item, index) in conditionData.cod_status"
                        :key="index"
                        :label="item"
                        :value="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="出库时间：" style="width: 500px">
                    <el-date-picker
                      v-model="form.out_time"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :default-time="['06:00:00', '06:00:00']"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="提交时间：" style="width: 500px">
                    <el-date-picker
                      v-model="form.update_time"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :default-time="['06:00:00', '06:00:00']"
                    >
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item>
                    <el-button type="success" @click="search">查询</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row v-if="!loading">
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button type="success" size="mini" @click="beforeSubCheck">
            提交财务审核</el-button
          >
          <el-button type="primary" size="mini" @click="output">导出</el-button>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.data"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="right"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column
              prop="wave_picking_no"
              label="波次号"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="shipping_num"
              label="快递单号"
              width="120"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="shipping_company"
              label="快递公司"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="user_id"
              label="用户ID"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="consignee"
              label="收货人姓名"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="out_time"
              label="出库日期"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="wave_picking_num"
              label="商品件数"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="price"
              label="发货商品金额"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="yf_price"
              label="用户应付金额"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="ml_price"
              label="抹零金额"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="fee"
              label="手续费"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="back_price"
              label="快递应返货款"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cod_base_type"
              label="处理类型"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cod_base_status"
              label="处理状态"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="update_admin"
              label="提交人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="update_time"
              label="提交时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(scope.row)"
                  >详情</el-button
                ><br
                  v-if="scope.row.status == 4 && scope.row.print_status != 1"
                />
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[50, 100, 200, 500, 1000]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>

        <el-dialog
          title="提交财务审核"
          :visible.sync="checkVisible"
          width="380"
        >
          <el-form style="margin-left: 10%">
            <el-form-item>
              <h1>
                处理类型:{{ check_type }}<br />

                包裹数量:{{ check_num }} 个<br />
                商品数量:{{ check_goods_num }} 件<br />
                快递公司:{{ check_shipping_company }}<br />
                应收金额:￥{{ check_money }}元<br />
              </h1>
            </el-form-item>
            <el-form-item label="提交说明">
              <el-input
                v-model="check_remark"
                type="textarea"
                placeholder="提交说明"
                @keyup.native.enter="search"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="checkVisible = false">取 消</el-button>
              <el-button type="primary" @click="subCheck">确 定</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<style>
.el-table .stock-row {
  background: #f7fd7b;
}
</style>
<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchCondition();
    });
  },
  data() {
    return {
      resData: [],
      conditionData: {
        shipping_company: [],
      },
      cityData: {},
      districtData: {},
      is_show_search_option: 0,
      search_type: "wave_picking_no",
      search_options: [
        { key: "wave_picking_no", name: "波次号" },
        { key: "shipping_num", name: "快递单号" },
        { key: "user_id", name: "用户id" },
        { key: "consignee", name: "收件人姓名" },
      ],
      search_value: "",
      form: {
        // update_time:this.defaultDate(),
        out_time: this.$excalibur.getDateTimeOnHours(-30, 6),
        multipleSelection: [],
        shipping_company: "",
        status: "",
        pagesize: 100,
      },
      origin_list: [
        {
          origin_id: 1,
          origin_name: "广州",
        },
        {
          origin_id: 2,
          origin_name: "杭州",
        },
      ],
      storehouseIds: [],
      show_log_time: 0,
      loading: false,
      url: "/erp/cod/index",
      origin: 1,
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      wave_num: 0,
      shipping_company: "",
      mark_type: 0,
      can_sub: 1,
      check_type: "",
      check_num: 0,
      check_goods_num: 0,
      check_shipping_company: "",
      check_money: 0,
      checkVisible: false,
      check_remark: "",
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    beforeSubCheck() {
      if (this.form.multipleSelection.length == 0) {
        return this.$message.error("请选择要提交的项目");
      }
      if (this.check_shipping_company === false) {
        return this.$message.error("选择的项目包含多个快递");
      }
      if (this.check_type === false) {
        return this.$message.error("选择的项目包含多个类型");
      }
      this.checkVisible = true;
    },
    subCheck() {
      this.$http
        .post("/erp/cod/subCheck", {
          wave_picking_ids: this.form.multipleSelection,
          check_remark: this.check_remark,
        })
        .then((res) => {
          setTimeout(() => {
            this.tableLoading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.checkVisible = false;
            this.$message.success(res.data.msg);
            this.fetchData();
          }
        });
    },
    handleSizeChange(val) {
      this.form.pagesize = val;
      this.fetchData(true);
    },
    output() {
      this.form.is_excel = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.loading = false;
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },

    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      this.shipping_company = "";
      this.wave_num = 0;
      this.can_sub = 1;

      // 提交审核的数据
      this.check_type = "";
      this.check_shipping_company = "";
      this.check_num = 0;
      this.check_goods_num = 0;
      this.check_money = 0;
      this.check_remark = "";

      for (const key in val) {
        if (this.shipping_company === "") {
          this.shipping_company = val[key].shipping_company;
        } else if (this.shipping_company != val[key].shipping_company) {
          this.shipping_company = false;
        }

        if (
          val[key].status != 1 &&
          val[key].status != 0 &&
          val[key].status != 6
        ) {
          this.can_sub = 0;
        }
        this.wave_num += 1;

        // 提交审核的数据
        if (this.check_shipping_company === "") {
          this.check_shipping_company = val[key].shipping_company;
        } else if (this.check_shipping_company != val[key].shipping_company) {
          this.check_shipping_company = false;
        }
        if (this.check_type === "") {
          this.check_type = val[key].cod_base_type;
        } else if (this.check_type != val[key].cod_base_type) {
          this.check_type = false;
        }
        this.check_num += 1;
        this.check_goods_num += parseInt(val[key].wave_picking_num);
        this.check_money += parseFloat(val[key].back_price);

        multipleSelection[key] = val[key].wave_picking_id;
      }
      this.form.multipleSelection = multipleSelection;
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.form).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleClick(row) {
      this.$router.push(
        `/home/wavepicking/wavepickinginfo/${row.wave_picking_id}`
      );
    },

    search() {
      this.form.page = 1;
      this.form.is_excel = 0;
      this.loading = true;
      this.fetchData(true);
    },
    selectOrigin(key) {
      this.form.origin = this.origin = key;
      // this.loading = true;
      // this.$http.post(this.url, this.filteredForm).then(res => {
      //     setTimeout(() => {
      //         this.loading = false;
      //     }, 200);
      //     if (res.data.code !== 200) {
      //         this.$message.error(res.data.msg);
      //         this.resData = res.data.data;
      //     } else {
      //         this.resData = res.data.data;
      //     }
      // });
    },

    fetchCondition() {
      this.$http.post("/erp/cod/condition").then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.conditionData = res.data.data;
          this.origin = res.data.data.origin;
        }
      });
    },
    fetchData(showLoading) {
      this.$http
        .post("/erp/StockStorehouse/listStockStorehouseConfig")
        .then((res) => {
          if (res.data.code == 200) {
            this.storehouseIds = res.data.data;
          }
        });
      if (showLoading) {
        this.loading = true;
      }

      if (this.search_value != "") {
        for (const key in this.search_options) {
          this.form[this.search_options[key].key] = "";
        }
        this.form[this.search_type] = this.search_value;
      } else {
        for (const key in this.search_options) {
          this.form[this.search_options[key].key] = "";
        }
      }

      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/cod/index.vue